import { LOCALES } from "utils/constants";

const translation = {
  [LOCALES.FA]: {
    PLACEHOLDER: "عبارت خود را جستجو کنید...",
    DATE: "تاریخ برگزاری",
    SEE_MORE: "مطالعه بیشتر",
    NOT_FOUND: "موردی یافت نشد!",
  },
  [LOCALES.EN]: {
    PLACEHOLDER: "Search...",
    DATE: "Date",
    SEE_MORE: "See More",
    NOT_FOUND: "Not Found!",
  },
} as const;

export default translation;
